// // import React, { useState } from "react";
// // import { GridColDef } from "@mui/x-data-grid";
// // import { ReportBaseTemplate } from "../../Components/ReportBaseTemplate";
// // import { callAPI ,LoacalVariables,Method } from "../../commonFunctions/CommonFunctions";
// // import dayjs from "dayjs";

// // export const ProfitLossReport: React.FC = () => {
// //   const [rows, setRows] = useState<any[]>([]);

// //   // later you can modify these column names
// //   const profitlossColumns: GridColDef[] = [
// //     { field: "accountId", headerName: "AccountId", flex: 1 },
// //     { field: "name", headerName: "Name", flex: 1 },
// //     { field: "totalCredit", headerName: "Total Credit", flex: 1 },
// //     { field: "totalDebit", headerName: "Total Debit", flex: 1 },
// //     { field: "netAmount", headerName: "Net Amount", flex: 1 },
// //   ];

// //  const handleApply = async (payload: any) => {
// //      try {
// //        const fromDate = dayjs(payload.fromDate).format("YYYY-MM-DD");
// //        const toDate = dayjs(payload.to).format("YYYY-MM-DD");
   
// //        const userId = localStorage.getItem(LoacalVariables.UserId);
// //        if (!userId) {
// //          alert("UserId not found. Please login again.");
// //          return;
// //        }
   
// //        console.log("Using userId:", userId);
   
// //        const query = `?fromdate=${fromDate}&to=${toDate}&userId=${userId}`;
   
// //        const response = await callAPI(
// //          `FinancialReport/profit-loss-Report${query}`,
// //          Method.GET
// //        );
   
// //        console.log("API Response:", response);
   
// //        // Map rows with unique id for DataGrid
// //        setRows(
// //          (response?.data?.report || []).map((row: any, index: number) => ({
// //            ...row,
// //            id: index,
// //          }))
// //        );
// //      } catch (err) {
// //        console.log("Error fetching Sales Report", err);
       

// //      }
// //    };
 
// //   return (
// //     <ReportBaseTemplate
// //       title="Profit & Loss Report"
// //       columns={profitlossColumns}
// //       rows={rows}
// //       onApply={handleApply}
// //     />
// //   );
// // };

// // export default ProfitLossReport;





// import React, { useState } from "react";
// import { Box, Button, TextField } from "@mui/material";
// import dayjs from "dayjs";
// import ProfitLossContent, { AccountRow } from "../../Components/ProfitLossContent";
// import { callAPI, Method, } from "../../commonFunctions/CommonFunctions";

// interface ProfitLossResponse {
//   totalRevenue: number;
//   totalExpenses: number;
//   netProfit: number;
//   incomeAccounts: AccountRow[];
//   expenseAccounts: AccountRow[];
// }

// const ProfitLossReport: React.FC = () => {
//   const [fromDate, setFromDate] = useState<string>(dayjs().format("YYYY-MM-DD"));
//   const [toDate, setToDate] = useState<string>(dayjs().format("YYYY-MM-DD"));
//   const [totalRevenue, setTotalRevenue] = useState<number>(0);
//   const [totalExpenses, setTotalExpenses] = useState<number>(0);
//   const [netProfit, setNetProfit] = useState<number>(0);
//   const [incomeRows, setIncomeRows] = useState<AccountRow[]>([]);
//   const [expenseRows, setExpenseRows] = useState<AccountRow[]>([]);

//   const handleApply = async () => {
//     try {
//       const query = `?fromdate=${fromDate}&to=${toDate}`;
//       const response = await callAPI(
//         `FinancialReport/profit-loss-Report${query}`,
//         Method.GET
//       );

//       setTotalRevenue(response?.data?.totalRevenue || 0);
//       setTotalExpenses(response?.data?.totalExpenses || 0);
//       setNetProfit(response?.data?.netProfit || 0);
//       setIncomeRows(response?.data?.incomeAccounts || []);
//       setExpenseRows(response?.data?.expenseAccounts || []);
//     } catch (err) {
//       console.log("Error fetching Profit Loss Report:", err);
//     }
//   };

//   return (
//     <Box>
//       {/* Date Filters */}
//       <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
//         <TextField
//           type="date"
//           label="From Date"
//           value={fromDate}
//           onChange={(e) => setFromDate(e.target.value)}
//           InputLabelProps={{ shrink: true }}
//         />
//         <TextField
//           type="date"
//           label="To Date"
//           value={toDate}
//           onChange={(e) => setToDate(e.target.value)}
//           InputLabelProps={{ shrink: true }}
//         />
//         <Button variant="contained" onClick={handleApply}>
//           Apply
//         </Button>
//       </Box>

//       {/* Stats & Tables */}
//       <ProfitLossContent
//         totalRevenue={totalRevenue}
//         totalExpenses={totalExpenses}
//         netProfit={netProfit}
//         incomeRows={incomeRows}
//         expenseRows={expenseRows}
//       />
//     </Box>
//   );
// };

// export default ProfitLossReport;

import React, { useState } from "react";
import dayjs from "dayjs";
import ProfitLossContent, { AccountRow } from "../../Components/ProfitLossContent";
import { ReportBaseTemplate } from "../../Components/ReportBaseTemplate";
import { callAPI, Method } from "../../commonFunctions/CommonFunctions";
import { LoacalVariables } from "../../commonFunctions/CommonFunctions";

const ProfitLossReport: React.FC = () => {
  const [totalRevenue, setTotalRevenue] = useState<number>(0);
  const [totalExpenses, setTotalExpenses] = useState<number>(0);
  const [netProfit, setNetProfit] = useState<number>(0);
  const [incomeRows, setIncomeRows] = useState<AccountRow[]>([]);
  const [expenseRows, setExpenseRows] = useState<AccountRow[]>([]);

  const handleApply = async (payload: any) => {
    try {
      const fromDate = dayjs(payload.fromDate).format("YYYY/MM/DD");
      const toDate = dayjs(payload.to).format("YYYY/MM/DD");

      const userId = localStorage.getItem(LoacalVariables.UserId);

      if (!userId) {
        alert("UserId not found. Please login again.");
        return;
      }

      console.log("Using userId:", userId);

      const query = `?from=${fromDate}&to=${toDate}&userid=${userId}`;

      const response = await callAPI(
        `FinancialReport/profit-loss-Report${query}`,
        Method.GET
      );

      console.log("ProfitLoss API Response:", response);

      // set values
      setTotalRevenue(response?.totalRevenue || 0);
      setTotalExpenses(response?.totalExpenses || 0);
      setNetProfit(response?.netProfit || 0);
      setIncomeRows((response?.incomeAccounts || []).map((row: any, index: number) => ({ ...row, id: index })));
      setExpenseRows((response?.expenseAccounts || []).map((row: any, index: number) => ({ ...row, id: index })));

    } catch (err) {
      console.log("Error fetching Profit Loss Report", err);
    }
  };

  return (
    <ReportBaseTemplate
      title="Profit & Loss Report"
      columns={[]}
      rows={[]}
      onApply={handleApply}
    >
      <ProfitLossContent
        totalRevenue={totalRevenue}
        totalExpenses={totalExpenses}
        netProfit={netProfit}
        incomeRows={incomeRows}
        expenseRows={expenseRows}
      />
    </ReportBaseTemplate>
  );
};

export default ProfitLossReport;
